<template>
  <framed-layout>

    <template #center>
      <h3 class="font-bold">Registreeru kasutajaks</h3>
    </template>

    <template #right>
      <router-link to="/" class="btn-circle">
        <i class="text-xl text-blue-500 pi pi-times"></i>
      </router-link>
    </template>

    <div class="max-w-4xl mx-auto">
      <h1 class="text-2xl font-bold leading-tight text-center md:text-4xl lg:text-5xl">
        Kellena soovid registreeruda?
      </h1>

      <div class="flex flex-wrap justify-between my-8 md:my-16 lg:my-24">
        <button
          :class="{ 'shadow-xl hover:shadow-xl': selected === 1 }"
          class="flex-1 px-6 py-8 mx-4 my-3 transition duration-150 bg-white rounded-lg outline-none md:py-12 hover:shadow-md"
          @click="selected = 1"
        >
          <icon
            name="user"
            stroke-width="2"
            width="78"
            height="78"
            vbWidth="78"
            vbHeight="78"
            :class="{ 'text-orange-400': selected === 1 }"
            class="mb-6 text-gray-600"
          />
          <div :class="{ 'text-gray-900': selected === 1 }" class="text-xl font-semibold text-gray-600">
            Tellijana
          </div>
        </button>

        <button
          :class="{ 'shadow-xl hover:shadow-xl': selected === 2 }"
          class="flex-1 px-6 py-8 mx-4 my-3 transition duration-150 bg-white rounded-lg outline-none md:py-12 hover:shadow-md"
          @click="selected = 2"
        >
          <icon
            name="user"
            stroke-width="2"
            width="78"
            height="78"
            vbWidth="78"
            vbHeight="78"
            :class="{ 'text-orange-400': selected === 2 }"
            class="mb-6 text-gray-600"
          />
          <div :class="{ 'text-gray-900': selected === 2 }" class="text-xl font-semibold text-gray-600">
            Projektijuhina
          </div>
        </button>

        <button
          :class="{ 'shadow-xl hover:shadow-xl': selected === 3 }"
          class="flex-1 px-6 py-8 mx-4 my-3 transition duration-150 bg-white rounded-lg outline-none md:py-12 hover:shadow-md"
          @click="selected = 3"
        >
          <icon
            name="compass"
            fill="currentColor"
            stroke="none"
            width="78"
            height="78"
            vbWidth="78"
            vbHeight="78"
            :class="{ 'text-orange-400': selected === 3 }"
            class="mb-6 text-gray-600"
          />
          <div :class="{ 'text-gray-900': selected === 3 }" class="text-xl font-semibold text-gray-600">
            Projekteerijana
          </div>
        </button>
      </div>

      <div class="flex flex-col items-center">
        <router-link :to="{ path: '/auth', query: {selected} }" class="w-56 text-white bg-orange-400 btn">Jätka</router-link>
      </div>
    </div>
  </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'

export default {
  components: {
    FramedLayout
  },
  metaInfo: {
    title: 'Registreeri kasutajaks',
    meta: [
      { property: 'og:title', content: 'Registreeri kasutajaks' },
      { property: 'robots', content: 'index, follow' },
    ]
  },
  data() {
    return {
      selected: 1
    }
  },
  methods: {
    //
  }
}
</script>
